import {useTranslation} from "react-i18next";
import {numberWithSpaces} from "../../../../../utils/helpers";

export const getBankCommissionsInfo = (summaryBankCommissions?: BankCommissionsSummary, totalCommissionPayment?: number) => {

  const { t } = useTranslation();

  if (!summaryBankCommissions) {
    return []
  }

  const invoicesBankCommissions = (summaryBankCommissions.invoices ?? []).map((invoice, invoiceIndex) => {
    const paymentsInfo = (invoice.banking_commissions ?? []).flatMap((payment, paymentIndex) => [
      {
        label: `${t('calc__text__bankCommissions__payment')} ${paymentIndex + 1} (${payment.commission_percentage}%)`,
        value: `${numberWithSpaces(payment.payment_amount)} USD`
      },
      {
        label: t('calc__text__bankCommissions__bankCommissionForTheTransfer'),
        value: `${numberWithSpaces(payment.bank_transfer_fee_usd)} USD`
      },
      {
        label: t('calc__text__bankCommissions__currencyControlCommission'),
        value: `${numberWithSpaces(payment.currency_control_fee_usd)} USD`
      }
    ]);

    return [
      {
        label: `${invoiceIndex + 1}. ${t('common__text__invoice')}`,
        value: `№ ${invoice.invoice_num}`
      },
      ...paymentsInfo
    ];
  });

  const paymentAmount = summaryBankCommissions.order_summary?.total_payment_amount
  const commissionAmount = summaryBankCommissions.order_summary?.total_payment_amount_with_commissions
  const totalPaymentWithCommissions = Number(paymentAmount) + Number(commissionAmount)
  const hasTotal = paymentAmount != null && commissionAmount != null && Number.isFinite(totalPaymentWithCommissions)

  return [
    ...invoicesBankCommissions,
    ...(hasTotal ? [ [
      {
        label: t('calc__text__bankCommissions__totalToBePaid'),
        value: `${numberWithSpaces(totalPaymentWithCommissions)} USD`
      }
    ] ] : [])
  ]
}
